//SERVER ROUTES
export const SERVER_URL = process.env.REACT_APP_PUBLIC_SERVER + "/api";
export const EMAIL_SERVER = SERVER_URL + '/createplateform';
export const ENTERPRISE_SERVER = SERVER_URL + '/enterprise';